



















import {Vue, Component} from 'vue-property-decorator';
import {Mutation, Getter, namespace} from 'vuex-class';
import {Filters} from '../image-editor/filters/filters';
import {downloadImage} from '../util/util';

const ImageFilterMutation = namespace('imageFilter', Mutation);
const ImageFilterGetter = namespace('imageFilter', Getter);

@Component
export default class ImageToolbar extends Vue {
  @ImageFilterMutation('toggleNavigator') private toggleNavigator: () => void;
  @ImageFilterGetter('selectedImage') private selectedImage: File;
  @ImageFilterGetter('filters') private filters: {[key: string]: Filters};

  private onMenuClicked() {
    this.toggleNavigator();
  }

  private onDownloadClicked() {
    if (this.selectedImage) {
      const currentImageName = this.selectedImage.name;
      const currentFilter = this.filters[currentImageName] ?
        this.filters[currentImageName].stringify() :
        '';

      downloadImage(this.selectedImage, currentFilter);
    }
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/image-filter/image-toolbar/image-toolbar.vue